import { Component, OnInit } from '@angular/core';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { NgForm,FormsModule } from '@angular/forms';

import { AuthService } from 'src/app/shared/services/auth/auth.service';
declare  var jQuery:  any;

@Component({
  selector: 'app-common',
  templateUrl: './common.component.html',
  styleUrls: ['./common.component.scss']
})
export class CommonComponent implements OnInit {

  subscriptionRequest: any= {};
  subscriptionError: any;
  subscriptionSuccess: any;
  intropage: boolean = false;
  hide_ad: boolean = false;
  homepage: boolean = false;
  loginpage: boolean = false;
  registerpage: boolean = false;
  addresspage: boolean = false;
  membershippage: boolean = false;
  eventpage: boolean = false;
  membershipsinglepage: boolean = false;
  evnetgracesinglepage: boolean = false;
  evnetsinglepage: boolean = false;
  confirmationpage: boolean = false;
  outdooreventpage: boolean = false;
  matchticketspage: boolean = false;
  loginmenu: boolean = false;
  forgotpage: boolean = false;
  membershipsingleurl: any = "";
  shopsingleurl: any = "";
  eventsingleurl: any = "";
  eventgracesingleurl: any = "";
  settingList: any = "";
  sponsorsList: any = "";
  user: any = "";
  autologinRequest: any= {};
  bannerrequest: any = {};
  sponsorrequest: any = {};
  bannerList: any = "";
  main_tabid = 19;
	livestatus: any = "Live";
  liverequest: any = {
		series_type_id: this.main_tabid,
		matche_status: this.livestatus
	};
  homematchrequest: any = {
		series_type_id: 15
	};
  livematchesList: any = "";
  homeupcomingList: any = "";
	livematcheList: any = "";
  footerSponsors: any = "";
  
  constructor(private router: Router,
    private allpagesService: AllPageService,
    public authService: AuthService,) { 
    router.events.subscribe((event) => {
    if (event instanceof NavigationEnd) {
     
      if(event.url=='/'){
        //console.log("cw quiz page");
        this.homepage = true;
      }
      else{
        this.homepage = false;
      }
      if(event.url=='/membership'){
        //console.log("cw quiz page");
        this.membershippage = true;
      }
      else{
        this.membershippage = false;
      }
      if(event.url=='/shop' || event.url=='/shop-cart' || event.url=='/checkout'){
        //console.log("cw quiz page");
        //this.loginmenu = true;
        this.loginmenu = false;
      }
      else{
        this.loginmenu = false;
      }
      if(event.url.includes('/shop')){
        //this.loginmenu = true;
        this.loginmenu = false;
        this.shopsingleurl = event.url;
      }else{
        this.loginmenu = false;
      }
      if(event.url=='/membership-single'){
        //console.log("cw quiz page");
        this.membershipsinglepage = true;
      }
      else{
        this.membershipsinglepage = false;
      }
      
      if(event.url=='/login'){
        //console.log("cw quiz page");
        this.loginpage = true;
      }
      else{
        this.loginpage = false;
      }
      if(event.url=='/register'){
        //console.log("cw quiz page");
        this.registerpage = true;
      }
      else{
        this.registerpage = false;
      }
      if(event.url=='/address'){
        //console.log("cw quiz page");
        this.addresspage = true;
      }
      else{
        this.addresspage = false;
      }
      if(event.url=='/event'){
        //console.log("cw quiz page");
        this.eventpage = true;
      }
      else{
        this.eventpage = false;
      }
      if(event.url=='/confirmation'){
        //console.log("cw quiz page");
        this.confirmationpage = true;
      }
      else{
        this.confirmationpage = false;
      }
      if(event.url=='/outdoorevent'){
        
        this.outdooreventpage = true;
      }
      else{
        this.outdooreventpage = false;
      }
      if(event.url=='/matchtickets'){
        //console.log("cw quiz page");
        this.matchticketspage = true;
      }
      else{
        this.matchticketspage = false;
      }
      if(event.url=='/forgot'){
        //console.log("cw quiz page");
        this.forgotpage = true;
      }
      else{
        this.forgotpage = false;
      }
      if(event.url.includes('/membership-single')){
        this.membershipsinglepage = true;
        this.membershipsingleurl = event.url;
      }else{
        this.membershipsinglepage = false;
      }
      if(event.url.includes('/event')){
       
        this.evnetsinglepage = true;
        this.eventsingleurl = event.url;
      }else{
        this.evnetsinglepage = false;
      }
      if(event.url.includes('/event/conference-and-events')){
       
        this.evnetgracesinglepage = true;
        this.eventgracesingleurl = event.url;
      }else{
        this.evnetgracesinglepage = false;
      }

    }
  });
 }
 slidepartnerConfig = {
  dots: false,
  infinite: true,
  arrows:false,
  slidesToShow: 8,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
};
  ngOnInit() {
    this.loadmatcheslive();
      jQuery(".header-mobile-menu-inner li.cricket-hover.mobile  span.arrow-down").click(function(){
        jQuery(".header-mobile-menu-inner li.cricket-hover").toggleClass("active");
        jQuery(".header-mobile-menu-inner ul li.cricket-hover.mobile span.arrow-down").toggleClass("active");
      }); 
      jQuery(".header-mobile-menu-inner ul li.event.mobile span.arrow-down").click(function(){
        jQuery(".header-mobile-menu-inner ul li.event").toggleClass("active");
        jQuery(".header-mobile-menu-inner ul li.event.mobile span.arrow-down").toggleClass("active");
      }); 
      jQuery(".header-mobile-menu-inner ul li.commercial.mobile span.arrow-down").click(function(){
        jQuery(".header-mobile-menu-inner ul li.commercial").toggleClass("active");
        jQuery(".header-mobile-menu-inner ul li.commercial.mobile span.arrow-down").toggleClass("active");
      });
      jQuery(".header-mobile-menu-inner ul li.squads.mobile span.arrow-down").click(function(){
        jQuery(".header-mobile-menu-inner ul li.squads").toggleClass("active");
        jQuery(".header-mobile-menu-inner ul li.squads.mobile span.arrow-down").toggleClass("active");
      }); 
      jQuery(".header-mobile-menu-inner ul li.ticket.mobile span.arrow-down").click(function(){
        jQuery(".header-mobile-menu-inner ul li.ticket").toggleClass("active");
        jQuery(".header-mobile-menu-inner ul li.ticket.mobile span.arrow-down").toggleClass("active");
      });
      jQuery(".header-mobile-menu-inner ul li.club.mobile span.arrow-down").click(function(){
        jQuery(".header-mobile-menu-inner ul li.club").toggleClass("active");
        jQuery(".header-mobile-menu-inner ul li.club.mobile span.arrow-down").toggleClass("active");
      }); 
      jQuery(".header-mobile-menu-inner li.community.mobile span.arrow-down").click(function(){
        jQuery(".header-mobile-menu-inner li.community").toggleClass("active");
        jQuery(".header-mobile-menu-inner ul li.community.mobile span.arrow-down").toggleClass("active");
      }); 
      jQuery(".header-mobile-menu-inner li.matches.mobile span.arrow-down").click(function(){
        jQuery(".header-mobile-menu-inner li.matches").toggleClass("active");
        jQuery(".header-mobile-menu-inner ul li.matches.mobile span.arrow-down").toggleClass("active");
      });
      jQuery(".header-mobile-menu-inner ul li a span.menu-name").click(function(){
        jQuery(".header-mobile-menu-inner li.cricket-hover").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.cricket-hover.mobile span.arrow-down").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.event").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.event.mobile span.arrow-down").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.commercial").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.commercial.mobile span.arrow-down").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.squads").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.squads.mobile span.arrow-down").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.ticket").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.ticket.mobile span.arrow-down").removeClass("active"); 
        jQuery(".header-mobile-menu-inner ul li.club").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.club.mobile span.arrow-down").removeClass("active"); 
        jQuery(".header-mobile-menu-inner ul li.community").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.community.mobile span.arrow-down").removeClass("active"); 
        jQuery(".header-mobile-menu-inner ul li.matches").removeClass("active");
        jQuery(".header-mobile-menu-inner ul li.matches.mobile span.arrow-down").removeClass("active");
      }); 
      jQuery(".header-mobile-menu-inner ul li.matches.mobile ul.event-submenu li a").click(function(){
        jQuery(".matches.mobile").removeClass("active");
        jQuery(".header-mobile-menu").removeClass("active");
        jQuery(".menu-icon").removeClass("active");
        jQuery(".arrow-down").removeClass("active");
        
      });
      jQuery(".header-mobile-menu-inner ul li.club.mobile ul.event-submenu li a").click(function(){
        jQuery(".club.mobile").removeClass("active");
        jQuery(".header-mobile-menu").removeClass("active");
        jQuery(".menu-icon").removeClass("active");
        jQuery(".arrow-down").removeClass("active");
      });
      jQuery(".header-mobile-menu-inner ul li.commercial.mobile ul.event-submenu li a").click(function(){
        jQuery(".commercial.mobile").removeClass("active");
        jQuery(".header-mobile-menu").removeClass("active");
        jQuery(".menu-icon").removeClass("active");
        jQuery(".arrow-down").removeClass("active");
      });
      jQuery(".header-mobile-menu-inner ul li.event.mobile ul.event-submenu li a").click(function(){
        jQuery(".event.mobile").removeClass("active");
        jQuery(".header-mobile-menu").removeClass("active");
        jQuery(".menu-icon").removeClass("active");
        jQuery(".arrow-down").removeClass("active");
      });
      jQuery(".header-mobile-menu-inner ul li.ticket.mobile ul.event-submenu li a").click(function(){
        jQuery(".ticket.mobile").removeClass("active");
        jQuery(".header-mobile-menu").removeClass("active");
        jQuery(".menu-icon").removeClass("active");
        jQuery(".arrow-down").removeClass("active");
      });
      jQuery(".header-mobile-menu-inner ul li.cricket-hover.mobile ul.event-submenu li a").click(function(){
        jQuery(".cricket-hover.mobile").removeClass("active");
        jQuery(".header-mobile-menu").removeClass("active");
        jQuery(".menu-icon").removeClass("active");
        jQuery(".arrow-down").removeClass("active");
      });
      jQuery(".header-mobile-menu-inner ul li.community.mobile ul.event-submenu li a").click(function(){
        jQuery(".community.mobile").removeClass("active");
        jQuery(".header-mobile-menu").removeClass("active");
        jQuery(".menu-icon").removeClass("active");
        jQuery(".arrow-down").removeClass("active");
      });
      jQuery(".header-mobile-menu-inner ul li.squads.mobile ul.event-submenu li a").click(function(){
        jQuery(".squads.mobile").removeClass("active");
        jQuery(".header-mobile-menu").removeClass("active");
        jQuery(".menu-icon").removeClass("active");
        jQuery(".arrow-down").removeClass("active");
      });
      
    this. loadBanner();
    this.allpagesService.getAppsetting().then((data) => {
      this.settingList = data;
     // console.log(this.settingList); 
    });

   this.loadsponser();
   jQuery(".popup-match-icon ul li.bat-boll a").click(function () {
    jQuery(".popup-match").addClass("open");
    jQuery(".popup-match-icon").addClass("open");
  });
  jQuery(".popup-match-icon ul li.close-popup a").click(function () {
    jQuery(".popup-match").removeClass("open");
    jQuery(".popup-match-icon").removeClass("open");
  });
  
    jQuery(".menu-icon").click(function(){
      jQuery(".menu-icon").toggleClass("active");
      jQuery(".header-mobile-menu").toggleClass("active");
      jQuery(".header-left-social-icon").toggleClass("active");
    });
    jQuery(".header-mobile-menu-inner-black").click(function(){
       jQuery(".header-mobile-menu").toggleClass("active");
       jQuery(".menu-icon").toggleClass("active");
       jQuery(".header-left-social-icon").toggleClass("active");
    });
    jQuery(".header-mobile-menu-left ul.enumenu_ul li a span.menu-name").click(function(){
      jQuery(".header-mobile-menu").removeClass("active");
      jQuery(".menu-icon").removeClass("active");
      jQuery(".header-left-social-icon").removeClass("active");
   });
   jQuery(".header-left-right-logo a").click(function(){
    jQuery(".header-mobile-menu").removeClass("active");
    jQuery(".menu-icon").removeClass("active");
    jQuery(".header-left-social-icon").removeClass("active");

   
 });
    
    this.autologinRequest = {
      devices_id: new Date().getTime(),
      devices_name: navigator.userAgent,
      app_version: 1,
      devices_type: 'Web',
      os: 'Android10'
     // device_token: navigator.userAgent,
    }
    this.authService.$user.subscribe((data) => {
      //console.log("login chhhhe");
      //console.log(data);
      if (data) {
       /// console.log("login chhhhe j");
        //console.log(data);
        this.user = data;
        this.checkautoLogin();
        //console.log(this.user.appuser_id);
        //this.checkautoLogin();
        //this.checkcart();
        //this.checkshopcart();
      } else {
        this.user = null;
       // console.log("login nathi");
      }
    });
    setTimeout(function () {
      jQuery(".header-main").addClass('active');
    }, 5000);

    this.allpagesService.getFootersponsors().then((data: any) => {
			this.footerSponsors = data.data;
			//console.log(this.footerSponsors);
		});

    let request = Object.assign({}, this.homematchrequest);
			this.allpagesService.getHomeScreenMatchesList(request).then((data: any) => {
				this.homeupcomingList = data.data.upcoming;
				
			});

  }
  loadsponser() {
    this.sponsorrequest = {
			is_home: 'Yes'
		};
		let request = Object.assign({}, this.sponsorrequest);
		this.allpagesService.getSponsors(request).then((data: any) => {
			this.sponsorsList = data.data[0]; 
		});
	}

  loadmatcheslive() {
		let request = Object.assign({}, this.liverequest);
		this.allpagesService.getMatcheslist(request).then((data: any) => {
			this.livematcheList = data;
			this.livematchesList = data.data[0];

			console.warn(this.livematchesList);
		});
	}
  toggleAd() {
    this.hide_ad = (!this.hide_ad)
  }
  logout() {
    this.authService.logout()
      .then(() => {
        this.router.navigate(['/home']);
      }).catch((err) => {
        //console.log(err);
      });
  }
  checkautoLogin(){
    let request:any = {
       
    };
    request = Object.assign({}, this.autologinRequest);
    this.authService.autologin(request).then(
      (res) => {
        if(res.status == 0){
          this.logout();
        }
        if(res.status == 1){
          
        }
      }).catch((err) => {
        //console.log(err);
      });
  }

  doSubscription(form: NgForm) {
    this.authService.registerSuccess = null;
    if (form.valid) {
      // this.loginRequest.email = jQuery("#login_email").val();
      // this.loginRequest.password = jQuery("#login_password").val();
      // //console.log(this.loginRequest.email);
       //console.log(form.value); 
      let request:any = {
       
      };
      request = Object.assign({}, this.subscriptionRequest);

      this.allpagesService.newsSubscription(request).then(async (_res) => {
        //console.log(_res);
            if (_res.status == 0) {

              this.subscriptionError = _res.message;
            } else {
              this.subscriptionSuccess = _res.message;
            }
            
             }).catch((err) => {
              //console.log({ err });
              this.subscriptionError =  err;
        });
      }    
  }

  loadBanner() {
		this.bannerrequest = {
			title: 'Newsletters'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data.data[0];
			//console.log(this.bannerList);
		});
	}

}
